import { Component, Input } from "@angular/core";
import type { PositionConfig, Values } from "./decision-tree.models";
import {
  createDecisionTreePositions,
  getDecisionTreePositions,
} from "./decision-tree-layout";
import {
  getDecisionTreeClass,
  getDecisionTreeImageKey,
  getDecisionTreeWarningIconClass,
} from "./decision-tree-presentation";

@Component({
  selector: "app-decision-tree",
  templateUrl: "./decision-tree.component.html",
  styleUrls: ["./decision-tree.component.scss"],
  standalone: false,
})
export class DecisionTreeComponent {
  @Input() values!: Values;
  @Input() hasSellout: boolean = false;
  @Input() hasVilcRef: boolean = false;
  @Input() isYtd: boolean = false;
  @Input() skuRecommendationVersion: string = "V3";

  private allPositions: PositionConfig[] = createDecisionTreePositions();

  get positions(): PositionConfig[] {
    return getDecisionTreePositions(this.allPositions, this);
  }

  get imageKey(): string {
    return getDecisionTreeImageKey(this);
  }

  get warningIconClass(): string {
    return getDecisionTreeWarningIconClass(this);
  }

  getDecisionTreeClass(): string {
    return getDecisionTreeClass(this);
  }
}
